export const FrontendMarkForListingStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
  UnderReview: 'Under Review',
  Sold: 'Sold',
  Draft: 'Draft',
};

export const ExternalIdGroupByOrigin = {
  RAE: 'E',
  Repliers: 'R',
  Pillar9: 'A',
};
